"use client";

import Script from "next/script";

/*
 * strategy is 'lazyOnload', NOT 'worker'. next/script's worker strategy is a silent
 * no-op in the App Router: its loader effect only handles afterInteractive and
 * lazyOnload, and the worker branch needs the Pages-Router HeadManagerContext
 * (updateScripts/getIsSsr), which app/ never provides. Nothing is injected, nothing
 * is logged — the tag simply never runs. This script was dead in production from
 * #323 (Oct 2024) until it was switched back. Partytown being installed and
 * nextScriptWorkers being on does not change that. Do not set it back to 'worker'.
 */
export default function LinkedIn() {
    return (
        <>
            <Script id="linkedInPartnerId" strategy={'lazyOnload'}>
                {`
                _linkedin_partner_id = "1546538";
                window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
                window._linkedin_data_partner_ids.push(_linkedin_partner_id);
                `}
            </Script>
            <Script id="linkedInScript"  strategy={'lazyOnload'}>
                {`
                (function (l) {
                    if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
                    window.lintrk.q=[]}
                    var s = document.getElementsByTagName("script")[0];
                    var b = document.createElement("script");
                    b.type = "text/javascript";b.async = true;
                    b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
                    s.parentNode.insertBefore(b, s);
                })(window.lintrk);
                `}
            </Script>
            <noscript>
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img height="1" width="1" style={{display: 'none'}} alt=""
                     src="https://px.ads.linkedin.com/collect/?pid=1546538&fmt=gif"/>
            </noscript>
        </>
    );
}